import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { ReactComponent as Architecture } from "../../../assets/icons/architecture.svg";
 
// const layers = [
//   {
//     icon: PersonIcon,
//     title: "クライアント",
//     text: "PC ／ Teams ／ SharePoint モバイルアプリ",
//   },
//   {
//     icon: CloudIcon,
//     title: "SPFx Webパーツ",
//     text: "App Catalogで配布・管理するカスタム画面",
//   },
//   {
//     icon: StorageIcon,
//     title: "SharePointの標準基盤",
//     text: "リスト／ライブラリ／Power Automate／権限設定",
//   },
// ];
 
const SystemArchitecture = () => {
  return (
    <Box sx={{ py: { xs: 6, md: 8 } }}>
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        <Box sx={{ mb: { xs: 2, md: 6 } }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "20px", md: "24px" },
              mb: { xs: 2, md: 2 },
            }}
          >
            【システム構成図】
          </Typography>
          <Typography sx={{ fontSize: "18px" }}>
            クライアントサイド：SPFx（React）Webパーツ／Extensions ─ サーバーサイド：SharePoint List・各種API連携。<br />
            App Catalog経由でSharePoint上にアプリを公開
          </Typography>
        </Box>
 
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            component={Architecture}
            sx={{ width: "100%", maxWidth: 1000, height: "auto" }}
          />
        </Box>
      </Container>
    </Box>
  );
};
 
export default SystemArchitecture;